import useSWR from "swr";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";

export const useSubAgents = (workspaceId: string | null, enabledOnly: boolean = true) => {
  const fetcher = async () => {
    if (!workspaceId) return [];
    const subAgents = await AgentService.getSubAgents(workspaceId);
    // enabledOnly=true の場合は enabled=true のサブエージェントだけをフィルタリング
    return enabledOnly ? subAgents.filter((sa) => sa.enabled) : subAgents;
  };

  const { data, error, isLoading, mutate } = useSWR(
    workspaceId ? ["agent", "subAgents", workspaceId, enabledOnly] : null,
    fetcher,
    defaultSWROption,
  );

  return {
    subAgents: data ?? [],
    error,
    isLoading,
    mutate,
  };
};
